import { CanvasElementType, CanvasObjectPosition, CanvasObjectSize, CanvasObjectStyles } from '@y42/json-schema';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles, defaultCanvasObjectProperties } from './default-canvas-model-properties';

const canvasAttentionStylesDefaultConstant: CanvasObjectStyles = {
  ...defaultCanvasGenericStyles,
};

const canvasAttentionDefaultSize: CanvasObjectSize = {
  width: 50,
  height: 50,
};

export function getCanvasAttentionModel(data: { position: CanvasObjectPosition; attachedTo?: string }) {
  return {
    type: CanvasElementType.Attention,
    position: data.position,
    size: canvasAttentionDefaultSize,
    typeSettings: {
      attachedTo: data.attachedTo,
    },
    styles: canvasAttentionStylesDefaultConstant,
    objectProperties: {
      ...defaultCanvasObjectProperties,
      resizable: false,
      selectable: false,
      rotatable: false,
    },
  };
}

export type CanvasAttentionModel = VisualizationCanvasElementStoreModel<CanvasElementType.Attention>;
